<template>
  <div>
    <app-spinner v-if="!page_loaded" />
    <template v-else>
      <h1 class="title">Storage Kitchen Equipment</h1>
      <app-cells><h2 class="title">Bulk items</h2></app-cells>
      <v-client-table
        :data="table_bulk.items"
        :columns="table_bulk.columns"
        :options="table_bulk.options"
        class="table-default"
        :class="{ 'table-default--loading': table_preloader_bulk }"
      >
        <template #name="{ row }">{{ row.public_name }}</template>
        <template #category="{ row }">{{ row.item?.category?.name || '-' }}</template>
        <template #stock="{ row }">{{ row.stock }}</template>
      </v-client-table>
      <app-cells position="between">
        <div>
          <paginate
            @input="onClickPagination"
            v-if="pagination_bulk.pages > 1"
            v-model="pagination_bulk.page"
            :page-count="pagination_bulk.pages"
            :prev-text="'<'"
            :next-text="'>'"
            :container-class="'pagination'"
            :page-class="'pagination__item'"
            :page-link-class="'pagination__link'"
            :prev-class="'pagination__item pagination__item--prev'"
            :next-class="'pagination__item pagination__item--next'"
            :next-link-class="'pagination__link pagination__link--next'"
            :prev-link-class="'pagination__link pagination__link--prev'"
          />
        </div>
        <app-table-records :all="pagination_bulk.count" :count="table_bulk.items.length" :page="pagination_bulk.page" :limit="40" />
      </app-cells>
    </template>
  </div>
</template>

<script>
import { getStorageItemsBulkKitchenEquipment } from '@/http'

export default {
  name: 'StorageKitchenEquipment',
  data() {
    return {
      page_loaded: false,
      table_bulk: {
        items: [],
        columns: [
          'name',
          'category',
          'stock',
        ],
        options: {
          headings: {
            'name': 'Name',
            'category': 'Category',
            'stock': 'Stock',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 40,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
      pagination_bulk: {
        pages: 1,
        page: 1,
        count: 1,
      },
      table_preloader_bulk: false,
    }
  },
  created() {
    Promise.all([this.fetchItemsBulk()])
      .then(() => {
        this.page_loaded = true
      })
  },
  methods: {
    async fetchItemsBulk() {
      this.table_preloader_bulk = true
      const response = await getStorageItemsBulkKitchenEquipment({
        page: this.pagination_bulk.page,
        page_size: 40,
      })
      this.table_bulk.items = response.data.results
      this.pagination_bulk.pages = response.data.pages
      this.pagination_bulk.count = response.data.count
      this.table_preloader_bulk = false
    },
    onClickPagination(page) {
      this.pagination_bulk.page = page
      this.fetchItemsBulk()
    },
  }
}
</script>
